import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedItems,
  handleSetSelectedFilterIds,
  handleSetSelectedFilterValue,
  handleToggleCollapsed,
  handleSetSelectedSentimentValues,
  handleSetSelectedContentBasedValues,
  handleSetSelectedCategories,
  handleChangeSortBy,
  handleSetAdvertFilterValues,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from './contentHelpers';
import { telegramFiltersInitialState } from './initialState/telegramInitialState';

export { telegramFiltersInitialState as filtersInitialState };
export const telegramContentInitialState = {
  filters: telegramFiltersInitialState,
  sortBy: {
    selected: 'time',
    order: 'desc',
  },
  selectedFilter: 'contentTagFilter',
};
export const telegramContentSlice = createSlice({
  name: 'telegramContentSlice',
  initialState: telegramContentInitialState,
  reducers: {
    setSelectedFilterIds: (state, action) => {
      handleSetSelectedFilterIds(state, action);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, telegramFiltersInitialState);
    },
    setSelectedSentimentValues: (state, action) => {
      handleSetSelectedSentimentValues(state, action);
    },
    setSelectedContentBasedValues: (state, action) => {
      handleSetSelectedContentBasedValues(state, action);
    },
    setSelectedCategories: (state, action) => {
      handleSetSelectedCategories(state, action);
    },
    changeSortBy: (state, action) => {
      handleChangeSortBy(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = telegramFiltersInitialState;
    },
    setAdvertFilterValues: (state, action) => {
      handleSetAdvertFilterValues(state, action);
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, telegramFiltersInitialState);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
  },
});

export const {
  setSelectedFilterIds,
  setSelectedItems,
  toggleCollapsed,
  resetAllFilters,
  resetFilter,
  setSelectedFilterValue,
  setSelectedCategories,
  setSelectedSentimentValues,
  setSelectedContentBasedValues,
  setAdvertFilterValues,
  changeSortBy,
  applyWebsiteSettingsFilters,
  setSelectedFilter,
} = telegramContentSlice.actions;
